import * as living from './living'
import * as usercenter from './usercenter'
const url = {...living,...usercenter}
export default url